import { render } from "./AtencionesPorSexo.vue?vue&type=template&id=69e22f7e&scoped=true"
import script from "./AtencionesPorSexo.vue?vue&type=script&lang=js"
export * from "./AtencionesPorSexo.vue?vue&type=script&lang=js"

import "./AtencionesPorSexo.vue?vue&type=style&index=0&id=69e22f7e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e22f7e"]])

export default __exports__